module.exports = __webpack_public_path__ + "static/img/plan2.fde3ff9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/plans/plan2.png
// module id = BTDO
// module chunks = 35